// Copyright 2020 Drivetrain Hub LLC
// GraphQL handler helpers.

import {formatValue} from "../../assets/js/utils";
import {UNITS} from "./units";

/**
 * Lookup function for parameter info, such as its description, symbol, and units.
 * @return {{desc: *, symbol: *, units: *}}
 * @param {Object} infoObj - Info lookup object.
 * @param {array} infoKeys - Info keys array.
 * @param {string} paramStr - String of parameter name.
 * @return {{index: (*|number), info: {desc: *, symbol: *, units: *}}} Object with index and info data.
 */
function lookupParamInfo(infoObj, infoKeys, paramStr) {
  const info = infoObj[paramStr];

  // NOTE: May not need if-condition.
  if (typeof info !== 'undefined') {
    return {
      index: infoKeys.indexOf(paramStr),
      info: {
        desc: info[0],
        symbol: info[1],
        units: info[2],
      },
    }
  }
}

function formatElTableValue(row, col, val) {
  // args follow Element UI pattern
  return formatValue(val);
}

function formatElTableLabel(lookupFcn, paramStr, units) {
  // Create param string label for filtered table column heading.
  // Example return value: '$\alpha_n$ (deg)'

  const {info} = lookupFcn(paramStr);
  const UNITS_LABEL = {...UNITS, ...units};

  return info.symbol + ' (' + UNITS_LABEL[info.units] + ')';
}

export default {
  lookupParamInfo: lookupParamInfo,
  formatElTableValue: formatElTableValue,
  formatElTableLabel: formatElTableLabel,
}
